import { TICKER_COLUMN } from "../../components/AssetTable/columns/Ticker";
import { ISIN_COLUMN } from "../../components/AssetTable/columns/Isin";
import { HOLDING_ADDRESS_COUNT_COLUMN } from "../../components/AssetTable/columns/Holders";
import {
    CIRCULATING_SUPPLY_TOKEN_COLUMN,
    TOTAL_SUPPLY_TOKEN_COLUMN,
} from "../../components/AssetTable/columns/TokenSupply";
import { TYPE_COLUMN } from "../../components/AssetTable/columns/Type";
import {
    REAL_ESTATE_ADDRESS_COLUMN_INLINE,
    REAL_ESTATE_CITY_COLUMN,
    REAL_ESTATE_COUNTRY_COLUMN,
    REAL_ESTATE_ASSET_TYPE_COLUMN,
    REAL_ESTATE_PROPERTY_TYPE_COLUMN,
    REAL_ESTATE_STRATEGY_COLUMN,
} from "../../components/AssetTable/columns/RealEstate";
import { NAME_COLUMN_INLINE } from "../../components/AssetTable/columns/AssetName";
import { PLATFORM_COLUMN } from "../../components/AssetTable/columns/Platform";
import { TOKENIZATION_TYPE_COLUMN } from "../../components/AssetTable/columns/TokenizationType";
import { TOKENIZATION_SPONSORSHIP_TYPE_COLUMN } from "../../components/AssetTable/columns/TokenizationSponsorshipType";
import { ASSET_CLASS_COLUMN } from "../../components/AssetTable/columns/AssetClass";
import { UNDERLYING_ASSETS_COLUMN_RIGHT_JUSTIFY } from "../../components/AssetTable/columns/UnderlyingAssets";
import {
    PRIMARY_MARKET_ALLOWED_INVESTORS_COLUMN,
    PRIMARY_MARKET_MINIMUM_SUBSCRIPTION_AMT_COLUMN,
    PRIMARY_MARKET_REDEMPTION_FEE_COLUMN,
    PRIMARY_MARKET_REDEMPTION_TIME_COLUMN,
    PRIMARY_MARKET_SUBSCRIPTION_FEE_COLUMN,
    PRIMARY_MARKET_KYC_DESCRIPTION_COLUMN,
    PRIMARY_MARKET_SUBSCRIPTION_DESCRIPTION_COLUMN,
    PRIMARY_MARKET_REDEMPTION_DESCRIPTION_COLUMN,
} from "../../components/AssetTable/columns/PrimaryMarket";
import { INCEPTION_DATE_COLUMN } from "../../components/AssetTable/columns/InceptionDate";
import { USE_OF_INCOME_COLUMN } from "../../components/AssetTable/columns/UseOfIncome";
import { MANAGEMENT_FEE_COLUMN } from "../../components/AssetTable/columns/ManagementFee";
import { TOTAL_PERFORMANCE_FEE_COLUMN } from "../../components/AssetTable/columns/TotalPerformanceFee";
import { BRIDGED_TOKEN_VALUE_DOLLAR_COLUMN } from "../../components/AssetTable/columns/BridgedTokenValueDollar";
import { TRAILING_30_DAY_ACTIVE_ADDRESSES_COUNT_COLUMN } from "../../components/AssetTable/columns/ActiveAddresses";
import { TRAILING_30_DAY_TRANSFER_COUNT_COLUMN } from "../../components/AssetTable/columns/TransferCount";
import { TRAILING_30_DAY_TRANSFER_VOLUME_COLUMN } from "../../components/AssetTable/columns/TransferVolume";
import { PRIMARY_MARKET_BASE_ASSETS_COLUMN } from "../../components/AssetTable/columns/PrimaryMarket";
import { PRIMARY_MARKET_SUBSCRIPTION_TIME_COLUMN } from "../../components/AssetTable/columns/PrimaryMarket";
import { ISSUER_COLUMN } from "../../components/AssetTable/columns/Issuer";
import { LICENSE_OR_REGULATORY_FRAMEWORK_INLINE } from "../../components/AssetTable/columns/RegulatoryFramework";
import {
    SUB_ADVISOR_COLUMN,
    CRYPTO_CUSTODIAN_COLUMN,
    FUND_ADMINISTRATOR_COLUMN,
    TRADITIONAL_BROKER_COLUMN,
    CRYPTO_BROKER_COLUMN,
    AUDITOR_COLUMN,
    TRANSFER_AGENT_COLUMN,
    PAYING_AGENT_COLUMN,
} from "../../components/AssetTable/columns/ServiceProviders";
import { ACCOUNT_SEGREGATION_COLUMN } from "../../components/AssetTable/columns/AccountSegregation";
import { APY_30_DAY_COLUMN } from "../../components/AssetTable/columns/Apy30Day";
import { APY_7_DAY_COLUMN } from "../../components/AssetTable/columns/Apy7Day";
import { BANKRUPCY_REMOTE_COLUMN } from "../../components/AssetTable/columns/BankruptcyRemote";
import { CUSIP_COLUMN } from "../../components/AssetTable/columns/Cusip";
import { DEPOSIT_INSURANCE } from "../../components/AssetTable/columns/DepositInsurance";
import { DISPUTE_RESOLUTION_COUNTRY_COLUMN } from "../../components/AssetTable/columns/DisputeResolutionCountry";
import { DOCUMENTS_COLUMN } from "../../components/AssetTable/columns/Documents";
import { INCORPORATION_COUNTRY_COLUMN } from "../../components/AssetTable/columns/IncorporationCountry";
import { MANAGER_COLUMN } from "../../components/AssetTable/columns/Manager";
import { MINIMUM_REDEMPTION_AMOUNT } from "../../components/AssetTable/columns/MinimumRedemptionAmount";
import { NET_ASSET_VALUE_COLUMN } from "../../components/AssetTable/columns/NetAssetValue";
import { OTHER_FEES_DESCRIPTION_COLUMN } from "../../components/AssetTable/columns/OtherFeesDescription";
import { PRICE_COLUMN } from "../../components/AssetTable/columns/Price";
import { TRADITIONAL_CUSTODIAN_WITH_LEI_OR_CIK_INLINE } from "../../components/AssetTable/columns/TraditionalCustodian";
import {
    ISSUER_LEI,
    ISSUER_CIK,
} from "../../components/AssetTable/columns/TreasuryIssuer";

// // // //
// V2 Page Columns

export const ASSET_KEY_FACTS_COLUMNS = [
    NAME_COLUMN_INLINE,
    TICKER_COLUMN,
    CUSIP_COLUMN,
    ISIN_COLUMN,
    PLATFORM_COLUMN,
    TOKENIZATION_TYPE_COLUMN,
    {
        ...TOKENIZATION_SPONSORSHIP_TYPE_COLUMN,
        renderOptions: { fullWidth: false },
    },
    TYPE_COLUMN,
    { ...MANAGER_COLUMN, loginRequired: false },
    ASSET_CLASS_COLUMN,
    { ...UNDERLYING_ASSETS_COLUMN_RIGHT_JUSTIFY, loginRequired: false },
    PRIMARY_MARKET_ALLOWED_INVESTORS_COLUMN,
    INCEPTION_DATE_COLUMN,
    USE_OF_INCOME_COLUMN,
    { ...MANAGEMENT_FEE_COLUMN, loginRequired: false },
    { ...TOTAL_PERFORMANCE_FEE_COLUMN, loginRequired: false },
];

export const ASSET_MARKET_DATA_FACTS_COLUMNS = [
    { ...BRIDGED_TOKEN_VALUE_DOLLAR_COLUMN, label: "Total Value" },
    { ...NET_ASSET_VALUE_COLUMN, loginRequired: false },
    // [ ] Market cap ------> TODO - CONFIRM WHICH MEASURE TO USE HERE
    // BRIDGED_TOKEN_MARKET_CAP_DOLLAR_COLUMN,
    { ...PRICE_COLUMN, loginRequired: false },
    { ...TOTAL_SUPPLY_TOKEN_COLUMN, loginRequired: false },
    { ...CIRCULATING_SUPPLY_TOKEN_COLUMN, loginRequired: false },
    // { ...BRIDGED_TOKEN_SUPPLY_TOKEN_COLUMN, loginRequired: false },
    { ...APY_7_DAY_COLUMN, loginRequired: false },
    { ...APY_30_DAY_COLUMN, loginRequired: false },
    { ...HOLDING_ADDRESS_COUNT_COLUMN, loginRequired: false },
    { ...TRAILING_30_DAY_ACTIVE_ADDRESSES_COUNT_COLUMN, loginRequired: false },
    { ...TRAILING_30_DAY_TRANSFER_COUNT_COLUMN, loginRequired: false },
    { ...TRAILING_30_DAY_TRANSFER_VOLUME_COLUMN, loginRequired: false },
];

export const ASSET_PRIMARY_MARKET_FACTS_COLUMNS = [
    { ...PRIMARY_MARKET_ALLOWED_INVESTORS_COLUMN, loginRequired: true },
    PRIMARY_MARKET_BASE_ASSETS_COLUMN,
    PRIMARY_MARKET_SUBSCRIPTION_TIME_COLUMN,
    PRIMARY_MARKET_MINIMUM_SUBSCRIPTION_AMT_COLUMN,
    PRIMARY_MARKET_SUBSCRIPTION_FEE_COLUMN,
    PRIMARY_MARKET_SUBSCRIPTION_DESCRIPTION_COLUMN,
    PRIMARY_MARKET_REDEMPTION_TIME_COLUMN,
    { ...MINIMUM_REDEMPTION_AMOUNT, loginRequired: true },
    PRIMARY_MARKET_REDEMPTION_FEE_COLUMN,
    PRIMARY_MARKET_REDEMPTION_DESCRIPTION_COLUMN,
    PRIMARY_MARKET_KYC_DESCRIPTION_COLUMN,
];

export const ASSET_LEGAL_AND_REGULATORY_FACTS_COLUMNS = [
    { ...ISSUER_COLUMN, loginRequired: true },
    // { ...PRIMARY_MARKET_ALLOWED_INVESTORS_COLUMN, loginRequired: true },
    { ...ISSUER_LEI, loginRequired: true },
    { ...ISSUER_CIK, loginRequired: true },
    INCORPORATION_COUNTRY_COLUMN,
    // [ ] Issuer - Licenses
    LICENSE_OR_REGULATORY_FRAMEWORK_INLINE,
    DISPUTE_RESOLUTION_COUNTRY_COLUMN,
    // [ ] Contractual redemption rights (boolean + description on hover)
    ACCOUNT_SEGREGATION_COLUMN,
    BANKRUPCY_REMOTE_COLUMN,
    DEPOSIT_INSURANCE,
    DOCUMENTS_COLUMN,
];

export const ASSET_SERVICE_PROVIDER_FACTS_COLUMNS = [
    PLATFORM_COLUMN,
    MANAGER_COLUMN,
    SUB_ADVISOR_COLUMN,
    // Bank ---------------- ??? ---> NOTE - these aren't available currently, circle back to fix (make a linear ticket)
    TRADITIONAL_CUSTODIAN_WITH_LEI_OR_CIK_INLINE,
    CRYPTO_CUSTODIAN_COLUMN,
    FUND_ADMINISTRATOR_COLUMN,
    TRADITIONAL_BROKER_COLUMN,
    CRYPTO_BROKER_COLUMN,
    AUDITOR_COLUMN,
    TRANSFER_AGENT_COLUMN,
    PAYING_AGENT_COLUMN,
];

export const ASSET_FEES_FACTS_COLUMNS = [
    MANAGEMENT_FEE_COLUMN,
    TOTAL_PERFORMANCE_FEE_COLUMN,
    OTHER_FEES_DESCRIPTION_COLUMN,
    PRIMARY_MARKET_REDEMPTION_FEE_COLUMN,
    PRIMARY_MARKET_SUBSCRIPTION_FEE_COLUMN,
];

export const REAL_ESTATE_FACTS_COLUMNS = [
    REAL_ESTATE_ADDRESS_COLUMN_INLINE,
    REAL_ESTATE_ASSET_TYPE_COLUMN,
    REAL_ESTATE_PROPERTY_TYPE_COLUMN,
    REAL_ESTATE_STRATEGY_COLUMN,
    REAL_ESTATE_CITY_COLUMN,
    REAL_ESTATE_COUNTRY_COLUMN,
];
